import React from 'react';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import KnowledgeBankEditForm, {IKnowledgeBankEditForm} from '../../../components/KnowledgeBank/EditForm';
import UseKnowledgeBank from '../../../hooks/apis/useKnowledgeBank';
import {Breadcrumb, Card, message} from 'antd';
import QuickRouter from '../../../utils/QuickRouter';
import useAuth from '../../../utils/AuthContext';
import useQuickRouter from '../../../utils/QuickRouter';
import CommonApiErrorHandler from '../../../utils/HttpInstance';

export default function ManageKnowledgeBankNewPage() {
  const auth = useAuth();
  const quickRouter = useQuickRouter();
  const saveState = UseKnowledgeBank.save();

  function save(form: IKnowledgeBankEditForm) {
    saveState
      .request(form)
      .then(() => {
        message.success('操作成功');
        return quickRouter.manageKnowledgeBankList();
      })
      .catch(CommonApiErrorHandler);
  }

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Breadcrumb className={'mb-md'}>
        <Breadcrumb.Item>
          <a onClick={quickRouter.index}>首页</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a onClick={quickRouter.manageKnowledgeBankList}>题库列表</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card title={'创建题库'}>
        <KnowledgeBankEditForm isLoading={saveState.loading} onFinish={save} />
      </Card>
    </div>
  );
}
